import customAxios from "./customAxios";

export const getSurveyorGoals = (baseUrl, userId, weekStartDate = null) => {
  const path = `${baseUrl}/surveyor_goals`;
  const params = { user_id: userId };

  if (weekStartDate) {
    params.week_start_date = weekStartDate;
  }

  return customAxios.get(path, { params })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};
